<template>
  <div>
    <div style="margin: 40px;">
      <el-row>
        <el-radio-group v-model="dateType">
          <el-radio :label="0">按天统计</el-radio>
          <el-radio :label="1">按月统计</el-radio>
        </el-radio-group>
        <span style="margin: 0 8px 0 70px; color: #606266; font-size: 14px;">选择时间范围</span>
        <el-date-picker
            v-model="date"
            :type="dateType === 0 ? 'daterange' : 'monthrange'"
            range-separator="至"
            :start-placeholder="dateType === 0 ? '开始日期' : '开始月份'"
            :end-placeholder="dateType === 0 ? '结束日期' : '结束月份'"/>
        <el-button style="margin-left: 50px;" type="primary" @click="getData">查询</el-button>
      </el-row>
    </div>
    <div class="chart" style="height: 350px;"/>
    <o-t-d-list ref="OTDList"/>
  </div>
</template>

<script>
  import OTDList from "./OTDList.vue";

  let moment = require("moment");
  export default {
    name: "OTD",
    components: {OTDList},
    data() {
      return {
        dateType: 0,
        date: "",
        dataX: [],
        dataY: [],
      };
    },
    mounted() {
      this.$nextTick(() => {
        this.initChart();
      });
    },
    methods:{
      getData() {
        if(!this.date.length) {
          this.$message.error("请先选择时间范围");
          return;
        }
        let params = {
          dateType: this.dateType,
          beginDate: moment(this.date[0]).utcOffset(480).format("YYYY-MM-DD"), //时间格式化
          endDate: moment(this.date[1]).utcOffset(480).format("YYYY-MM-DD"),
        };
        this.$http
          .get("basic", "sd/so/otd/yixin", params)
          .then(resp => {
            this.dataX = [];
            this.dataY = [];
            let data = resp;
            for(let item of data) {
              this.dataX.push(item.otdDate);
              this.dataY.push(item.otd);
            }
            this.initChart();
          });
      },
      initChart() {
        let myChart = this.$echarts.init(document.querySelector(".chart"));
        myChart.off("click");
        let option = {
          color: ["#3398DB"],
          tooltip : {
            trigger: "axis",
            axisPointer : {
              type : "shadow",
            },
          },
          grid: {
            left: "5%",
            right: "4%",
            bottom: "1%",
            containLabel: true,
          },
          xAxis : [
            {
              type : "category",
              data : this.dataX,
              axisTick: {
                alignWithLabel: true,
              },
            },
          ],
          yAxis : [
            {
              type : "value",
              name : "百分比",
              nameTextStyle:{
                color : "#2D8CF0",
                fontSize : 16,
              },
            },
          ],
          series : [
            {
              name:"百分比",
              type:"bar",
              barWidth: "40%",
              data: this.dataY,
              itemStyle: {
                normal: {
                  label: {
                    show: true,
                    position: "top",
                    formatter: function(a) {
                      let result = [],
                          counter = 0,
                          num = a.data;
                      num = (num || 0).toString().split("");
                      for (let i = num.length - 1; i >= 0; i--) {
                        counter++;
                        result.unshift(num[i]);
                        if (!(counter % 3) && i != 0) {
                          result.unshift(",");
                        }
                      }
                      result = result.join("") + "%";
                      return result;
                    },
                  },
                },
              },
            },
          ],
        };
        myChart.on("click", params => {
          this.$refs.OTDList.open(params.name);
        });
        myChart.setOption(option);
      },
    },
  };
</script>